import { emailSchema, numberRequiredSchema, optionalPasswordSchema, phoneRequiredSchema, stringOptionalSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
import { boolean, number, object, string } from 'yup';

const updateEmailSchema = object().shape({
    email: emailSchema,
    showOtpInput: boolean(),
    otp: string().when('showOtpInput', {
        is: (val) => val == true,
        then: () => stringRequiredSchema,
        otherwise: () => stringOptionalSchema,
    }),
});

export default updateEmailSchema;